import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Textarea from '../../../components/ui/Textarea';
import Button from '../../../components/ui/Button';
import CamperPreview from './CamperPreview';

export default function CampfireEditor({ data, globalFb, onSave, onHistory }) {
  const [form, setForm] = useState(data || {});
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => setForm(data || {}), [data]);

  const handleChange = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div className="flex flex-col lg:flex-row gap-8">
      <div className="flex-1 space-y-4">
        <div className="flex gap-4 items-end">
          <div className="flex-1">
            <Textarea 
              label="Reflection prompt" 
              value={form.prompt || ''} 
              onChange={e => handleChange('prompt', e.target.value)} 
              className="min-h-[80px]"
            />
          </div>
          
          <button 
            type="button"
            className="flex items-center gap-3 cursor-pointer p-2 bg-gray-50 border rounded-md hover:bg-gray-100 mb-0.5"
            onClick={() => handleChange('is_active', form.is_active ? 0 : 1)}
          >
            <div className={`w-10 h-6 rounded-full relative transition-colors ${form.is_active ? 'bg-green-500' : 'bg-gray-300'}`}>
              <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-all ${form.is_active ? 'left-5' : 'left-1'}`}></div>
            </div>
            <span className="font-bold text-gray-700">Active</span>
          </button>
        </div>

        <Input 
          label="Facebook Link Override" 
          value={form.fb_link || ''} 
          onChange={e => handleChange('fb_link', e.target.value)} 
          placeholder={globalFb ? `Leave empty to use global: ${globalFb}` : "https://facebook.com/groups/..."}
        />

        <Textarea 
          label="Encouragement note" 
          value={form.encouragement_note || ''} 
          onChange={e => handleChange('encouragement_note', e.target.value)} 
          className="min-h-[80px]"
        />

        <div className="grid md:grid-cols-2 gap-4">
          <Input 
            type="datetime-local" 
            label="Unlock Time" 
            value={form.unlock_time || ''} 
            onChange={e => handleChange('unlock_time', e.target.value)} 
          />
          <Input 
            type="datetime-local" 
            label="Close Time" 
            value={form.close_time || ''} 
            onChange={e => handleChange('close_time', e.target.value)} 
          />
        </div>

        <div className="flex gap-3 pt-4 border-t border-gray-200">
          <Button onClick={() => onSave(form)}>Save The Commons</Button>
          <Button variant="ghost" onClick={onHistory}>View History</Button>
        </div>
      </div>

      <div className={`w-full lg:w-[400px] ${showPreview ? 'block' : 'hidden lg:block'}`}>
        <CamperPreview type="campfire" data={form} />
      </div>

      <button 
        className="lg:hidden w-full py-2 bg-gray-100 text-sm font-bold text-gray-600 rounded mt-4" 
        onClick={() => setShowPreview(!showPreview)}
      >
        {showPreview ? 'Hide Preview' : 'Show Preview'}
      </button>
    </div>
  );
}